module.exports = __webpack_public_path__ + "img/shiba-loading.2c470001.png";